(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltController', OltController);

    OltController.$inject = ['$scope', 'OltService', 'OltData'];

    function OltController($scope, OltService, OltData) {
        var vm = this;
        OltData.reset();
        vm.data = OltData;

        OltData.requestRunning = true;
        OltService.listOlts(null, true).then(function (data) {
            OltData.setArrayOlts(data);
            OltData.requestRunning = false;
        });

        vm.addOlt = function () {
            OltService.addOltModalConstructor();
        }

        vm.hasNoOlt = function () {
            return !OltData.arrayOlts.length && OltData.dataLoaded == true && !OltData.isSearch;
        }

        vm.hasOltOrSearch = function () {
            return OltData.arrayOlts.length || OltData.isSearch;
        }

    }
})();
